import { selectors } from 'publisher/reducers/filesReducer'
import { shallowEqual, useSelector } from 'react-redux'

export { selectors }

export default function useFiles(selector) {
  return useSelector(state => selector(state.files), shallowEqual)
}
